import { main } from "./index.js";

const PARENT = "maisey";

async function checkSession() {
  const res = await fetch("/api/christening/session");
  return res.ok;
}

async function login(password) {
  const res = await fetch("/api/christening/login", {
    method: "POST",
    body: JSON.stringify({ password }),
  });
  return res.ok;
}

const URL_CACHE_KEY = "maisey:urls";
const URL_CACHE_REFRESH_MARGIN_MS = 5 * 60 * 1000;

function loadURLCache() {
  try { return JSON.parse(localStorage.getItem(URL_CACHE_KEY) || "{}"); }
  catch { return {}; }
}

function saveURLCache(c) {
  try { localStorage.setItem(URL_CACHE_KEY, JSON.stringify(c)); } catch {}
}

async function fetchMediaURL(id, variant) {
  const key = variant ? `${id}:${variant}` : id;
  const cache = loadURLCache();
  const hit = cache[key];
  if (hit && hit.expires_at * 1000 - Date.now() > URL_CACHE_REFRESH_MARGIN_MS) {
    return { url: hit.url, expires_at: hit.expires_at };
  }
  const qs = variant ? `?variant=${encodeURIComponent(variant)}` : "";
  const res = await fetch(`/api/christening/media/${encodeURIComponent(id)}${qs}`);
  if (!res.ok) throw new Error(`media ${id}: ${res.status}`);
  const json = await res.json();
  cache[key] = { url: json.url, expires_at: json.expires_at };
  saveURLCache(cache);
  return json;
}

function showLocked() {
  document.querySelector("#locked").classList.remove("hidden");
  document.querySelector("#locked").classList.add("flex");
}

function hideLocked() {
  const el = document.querySelector("#locked");
  el.classList.add("hidden");
  el.classList.remove("flex");
}

function showUnlocked() {
  const el = document.querySelector("#unlocked");
  el.classList.remove("hidden");
  el.classList.add("flex");
  document.querySelector("#messages-link").classList.remove("hidden");
}

async function renderGallery() {
  const list = document.querySelector("#gallery");
  let items;
  try {
    const res = await fetch("/api/christening/manifest");
    if (!res.ok) throw new Error(`manifest: ${res.status}`);
    items = await res.json();
  } catch (e) {
    console.error(e);
    document.querySelector("#gallery-error").classList.remove("hidden");
    return;
  }
  if (!items || items.length === 0) {
    document.querySelector("#gallery-empty").classList.remove("hidden");
    return;
  }
  for (const item of items) {
    if (item.kind === "video") {
      const node = document.querySelector("#template-video").content.cloneNode(true);
      const video = node.querySelector("video");
      try {
        const { url } = await fetchMediaURL(item.id, "poster");
        if (url) video.poster = url;
      } catch (e) { /* poster optional */ }
      try {
        const { url } = await fetchMediaURL(item.id);
        video.src = url;
      } catch (e) { console.error(e); }
      video.addEventListener("error", async () => {
        if (!video.error) return;
        try {
          const { url } = await fetchMediaURL(item.id);
          if (url !== video.src) {
            video.src = url;
            video.play().catch(() => {});
          }
        } catch (e) { console.error(e); }
      });
      list.appendChild(node);
    } else {
      const node = document.querySelector("#template-photo").content.cloneNode(true);
      const img = node.querySelector("img");
      img.alt = item.caption || "";
      try {
        const { url } = await fetchMediaURL(item.id, item.thumb ? "thumb" : "");
        img.src = url;
      } catch (e) { console.error(e); }
      img.addEventListener("click", async () => {
        const dialog = document.querySelector("dialog");
        try {
          const { url } = await fetchMediaURL(item.id);
          dialog.querySelector("img").src = url;
          dialog.querySelector("p").textContent = item.caption || "";
          dialog.showModal();
        } catch (e) { console.error(e); }
      });
      list.appendChild(node);
    }
  }

}

function wireLightbox() {
  const dialog = document.querySelector("dialog");
  if (!dialog) return;
  dialog.querySelector("span")?.addEventListener("click", () => dialog.close());
  dialog.addEventListener("click", (e) => {
    if (e.target === dialog.querySelector("img")) return;
    const r = dialog.getBoundingClientRect();
    if (e.clientY < r.top || e.clientY > r.bottom || e.clientX < r.left || e.clientX > r.right) {
      dialog.close();
    }
  });
}

async function unlock() {
  hideLocked();
  showUnlocked();
  wireLightbox();
  await renderGallery();
  main(PARENT);
}

(async () => {
  if (await checkSession()) {
    await unlock();
    return;
  }
  showLocked();
  const form = document.querySelector("#login-form");
  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    const pw = document.querySelector("#login-password").value;
    const err = document.querySelector("#login-error");
    err.classList.add("hidden");
    const btn = document.querySelector("#login-submit");
    btn.disabled = true;
    try {
      if (await login(pw)) {
        await unlock();
      } else {
        err.classList.remove("hidden");
        btn.disabled = false;
      }
    } catch (e) {
      console.error(e);
      err.classList.remove("hidden");
      btn.disabled = false;
    }
  });
})();
